import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import AuthCode from "react-auth-code-input";
import { Link, Navigate, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import { getCategories, getCitiesByState, getServicesTypes, getStates } from "../api";
import { api_url } from "../constant";
import { useAuth } from "../store/authProvider";
import handelPhonenumber from "../utils/handel_phonenumber";
import main from "../images/main.png";
import logo from "../images/logo.png";
import { MultiSelect } from "../components/multiSelect";
import ReactGA from "react-ga4";
import { analyticsEvent } from "../utils/analytic_evetns";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";

function Signup() {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Signup Page",
  });
  const { getValues, setValue, reset } = useForm();
  const [information, setInformation] = useState({});
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [subCategory, setSubCategory] = useState([]);
  const [service, setService] = useState([]);
  const [files, setFiles] = useState([]);
  const [media, setMedia] = useState([]);
  const [otpModal, setOtpModal] = useState(false);
  const [otp, setOtp] = useState();
  const [val, setVal] = useState(information.phone);
  const { isAuth, setToken } = useAuth();
  const navigate = useNavigate();

  const allowedExtensions = ["jpg", "jpeg", "png", "gif", "pdf"];

  // Function to handle forget password - redirect to admin WhatsApp
  const handleForgetPassword = () => {
    // Admin WhatsApp number - replace with actual admin number
    const adminWhatsAppNumber = "249117028638"; // Replace with actual admin number

    // Message to send to admin
    const message = `مرحبا، أريد استعادة كلمة المرور لحسابي.`;

    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);

    // Create WhatsApp URL
    const whatsappUrl = `https://wa.me/${adminWhatsAppNumber}?text=${encodedMessage}`;

    // Open WhatsApp in new tab
    window.open(whatsappUrl, '_blank');

    // Show confirmation message
    toast.info("سيتم فتح واتساب للتواصل مع المسؤول لاستعادة كلمة المرور", {
      position: "top-center",
      autoClose: 5000,
    });
  };

  const upload = (file) => {
    if (file) {
      // Check file size (10 MB limit)
      const maxSizeMB = 10;
      if (file.size > maxSizeMB * 1024 * 1024) {
        toast.error(`File size exceeds ${maxSizeMB} MB`);
        return;
      }

      // Check number of files (maximum of 5)
      if (files.length >= 5) {
        toast.error('You can only upload up to 5 files');
        return;
      }

      // Add file to local state
      setFiles((prevFiles) => {
        if (prevFiles.length < 5) {
          return [...prevFiles, file];
        }
        return prevFiles;
      });

      // Preview the file (if needed)
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        setMedia((prevMedia) => [...prevMedia, e.target.result]);
      };
      fileReader.readAsDataURL(file);
    }
  };

  const uploadFiles = async (userId) => {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append(`files`, file);
    });

    let response = await fetch(`${api_url}/files/upload`, {
      method: "POST",
      body: formData,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      }
    }).then((res) => res.json());

    if (response.statusCode > 201) {
      if (response.statusCode === 401) {
        toast("ليس لديك الصلاحيات لرفع الملفات", { type: "error" });
        return;
      }
      toast("خطأ في رفع الملفات", { type: "error" });
      return;
    }
    toast(" تم تسجيل الحساب بنجاح ", { type: "success" });
  };

  let registerResponse;
  const register = async () => {
    console.log('Selected City ID:', information.city);
    if (
      (!information.password ||
        !information.phonenumber ||
        !information.type ||
        !information.dob ||
        !information.name ||
        !information.gender ||
        !state ||
        (subCategory.length === 0 && service.length === 0)) &&
      information.type !== "cooperative" &&
      information.type !== "service_provider"
    ) {
      toast("رجاءََ إدخل الحقول المطلوبه", { type: "error" });
      return;
    }
    if (information.password !== information.repassword) {
      toast("كلمة المرور غير متطابقة", { type: "error" });
      return;
    }

    if (information.password.length < 6) {
      toast("كلمة المرور يجب أن تكون 6 أحرف على الأقل", { type: "error" });
      return;
    }

    let response = await fetch(api_url + "/auth/register", {
      method: "POST",
      body: JSON.stringify({
        ...information,
        location: state && state.value,
        city: information.city,
        subCategory_id:
          information.type !== "service_provider"
            ? subCategory && subCategory.map((e) => e.value)
            : [],
        service_id:
          information.type === "service_provider"
            ? service && service.map((e) => e.value)
            : [],
      }),
      headers: { "Content-Type": "application/json" },
    }).then((res) => res.json());

    if (response.status > 201) {
      if (response.code === "BAD_REQUEST") {
        toast("رقم الهاتف غير صحيح", { type: "error" });
        return;
      } else {
        if (response.code === "INTERNAL_SERVER_ERROR") {
          toast(response.message, { type: "error" });
          return;
        } else {
          if (response.code === "THIS_PHONENUMBER_IS_REGISTERD_BEFORE") {
            toast("رقم الهاتف مسجل مسبقا", { type: "error" });
            return;
          }
        }
      }
    }
    if (
      response.statusCode === 400 &&
      response.message === "Validation failed"
    ) {
      toast("تم إدخال حقل بشكل خاطئ", { type: "error" });
      return;
    }
    if (
      response.statusCode === 400 &&
      response.message === "This phonenumber is registerd before"
    ) {
      toast("رقم الهاتف مسجل مسبقا", { type: "error" });
      return;
    }

    if (response.access_token) {
      setOtpModal(false);
      analyticsEvent("Signup", "User created successfully", "Signup");
      localStorage.setItem("token", response.access_token);
      localStorage.setItem("user_id", response.user_id);
      localStorage.setItem("type", response.type);
      localStorage.setItem("cooperativeType", response.cooperativeType);
      localStorage.setItem("isVerified", response.isVerified);
      // Trigger file upload after registration
      if (files.length > 0) {
        console.log(files);
        await uploadFiles(response.user_id);
      }
      navigate("/");
      window.location.reload();
    }
  };

  const sendOTP = async () => {
    if (!information.password || !information.phonenumber) {
      toast("رجاءََ إدخل الحقول المطلوبه", { type: "error" });
      return;
    }
    if (information.password !== information.repassword) {
      toast("كلمة المرور غير متطابقة", { type: "error" });
      return;
    }
    let response;
    response = await fetch(api_url + "/users/send-verification", {
      method: "POST",
      body: JSON.stringify({ phonenumber: information.phonenumber }),
      headers: { "Content-Type": "application/json" },
    }).then((res) => res.json());
    if (response.status > 201) {
      if (response.code === "VERIFICATION_CODE_ALREADY_SENT") {
        toast("لقد تم ارسال رمز التحقق", { type: "error" });
        setOtpModal(true);
        return;
      } else if (response.code === "USER_IS_ALREADY_REGISTERED") {
        toast("رقم الهاتف مسجل مسبقا", { type: "error" });
        return;
      } else {
        if (response.code === "INTERNAL_SERVER_ERROR") {
          toast(response.message, { type: "error" });
          return;
        }
      }
    }
    setOtpModal(true);
  };
  const verification = async () => {
    let response;
    response = await fetch(api_url + "/users/verify", {
      method: "POST",
      body: JSON.stringify({
        verificationCode: otp,
        phonenumber: information.phonenumber,
      }),
      headers: { "Content-Type": "application/json" },
    }).then((res) => res.json());
    if (response.status > 201) {
      if (
        response.code === "WRONG_VERIFICATION_CODE" ||
        response.code === "BAD_REQUEST"
      ) {
        toast("رقم التحقق غير صحيح", { type: "error" });
        return;
      }
    }
    if (response.verified) {
      register();
    }
  };

  var login = () => {
    if (information.password !== information.repassword) {
      toast("كلمة المرور غير متطابقة", { type: "error" });
      return;
    }

    var axios = require("axios");

    var data = JSON.stringify({
      phonenumber: information.phones,
      password: information.password,
    });
    var config = {
      method: "post",
      url: "https://api.ticketing.sd/auth/login",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        setToken(response.data.access_token);
        localStorage.setItem("auth", true);
        window.location.reload();
        navigate("/");
      })
      .catch(function (error) {
        toast("الرجاء التأكد من البيانات", { type: "error" });
      });
  };

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const { data: cities, refetch: citiesRefetch } = useQuery({
    queryKey: ["cities", state?.value],
    queryFn: () => getCitiesByState(state?.value),
    initialData: [],
    enabled: !!state, // Enable only if state is selected
  });

  const { data: subCategories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    initialData: [],
  });

  const { data: services } = useQuery({
    queryKey: ["services"],
    queryFn: () => getServicesTypes(),
    initialData: [],
  });

  const handleOnChange = (res) => {
    setOtp(res);
  };

  if (isAuth) {
    return <Navigate replace to="/"></Navigate>;
  }

  return (
    <>
      <Helmet>
        ‍<title>إنشاء حساب</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="إنشاء حساب" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      {otpModal && (
        <div
          className={`absolute w-screen h-screen bg-black z-50 bg-opacity-50 flex justify-center items-center 
          
        }`}
        >
          <div className="w-96 h-96 bg-white flex flex-col text-center justify-evenly items-center rounded-lg border-primary border-[2px]">
            <div className="font-bold">
              <div className="mb-2">
                : الرجاء إدخال رمز التحقق المرسل لرقم الهاتف
              </div>
              <p>{`${information.phonenumber}`}</p>
            </div>
            <AuthCode onChange={handleOnChange} inputClassName="input" />
            <button
              className="bg-primary w-20 h-10 rounded-md text-white"
              onClick={() => verification()}
            >
              موافق
            </button>
          </div>
        </div>
      )}
      <div className="flex  bg-flipped-background  bg-no-repeat bg-right-bottom bg-60% lg:bg-50%">
        <div className="hidden lg:block">
          <img src={main} alt="" className="h-screen " />
        </div>
        <div className="flex flex-col lg:scale-[0.89] w-full p-2 lg:p-0 lg:w-[30rem] mx-auto items-center  ${/*justify-center lg:h-screen*/}">
          <img src={logo} alt="" className="w-20" />

          <div className="flex flex-col items-center w-full  gap-2 my-5">
            <div className="w-full">
              <ReactSelect
                options={[
                  { label: "تعاونية زراعية إنتاجية", value: "farmar_cooperative" },
                  { label: "تعاونية إستهلاكية", value: "consumer_cooperative" },
                  { label: "شركة", value: "service_provider" },
                  // { label: "شركة", value: "supplier" },
                  { label: "مزارع", value: "farmer" },
                  { label: "مشتري", value: "buyer" },
                ]}
                styles={dropdownStyles}
                onChange={(e) => {
                  if (e.value === "farmar_cooperative") {
                    setInformation({
                      ...information,
                      type: "cooperative",
                      cooperativeType: "agriculture"
                    });
                  } else if (e.value === "consumer_cooperative") {
                    setInformation({
                      ...information,
                      type: "cooperative",
                      cooperativeType: "consumer"
                    });
                  } else {
                    setInformation({
                      ...information,
                      type: e.value,
                    });
                  }
                  analyticsEvent("User Type", e.value);
                }}
                hideSelectedOptions={false}
                closeMenuOnSelect={true}
                isRtl
                placeholder={
                  <span className="after:content-['*'] after:mr-0.5 after:text-red-500">
                    نوع العميل
                  </span>
                }
              />
            </div>
            <div className="w-full flex flex-row gap-2">

              <div className="w-full">
                <ReactSelect
                  options={cities?.map((e) => ({ label: e.name, value: e.id }))}
                  value={city}
                  onChange={(value) => {
                    setCity(value);
                    setInformation({
                      ...information,
                      city: value ? value.value : null, // Set city as number
                    });
                  }}
                  styles={dropdownStyles}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={true}
                  isRtl
                  placeholder={
                    <span className="">
                      المدينة
                    </span>
                  }
                  isDisabled={cities.length === 0}
                />
              </div>

              <div className="w-full">
                <ReactSelect
                  options={states.map((e) => {
                    return { label: e.name, value: e.id };
                  })}
                  styles={dropdownStyles}
                  onChange={(value) => (
                    setState(value),
                    analyticsEvent("Location", value.label),
                    citiesRefetch()
                  )}
                  hideSelectedOptions={false}
                  required
                  closeMenuOnSelect={true}
                  isRtl
                  placeholder={
                    <span className="after:content-['*'] after:mr-0.5 after:text-red-500">
                      الولاية
                    </span>
                  }
                />
              </div>
            </div>

            {information.type ? (
              information.type === "service_provider" ? (
                <div className="w-full">
                  <MultiSelect
                    options={services.map((e) => {
                      return { label: e.name, value: e.id };
                    })}
                    value={service}
                    onChange={setService}
                    styles={dropdownStyles}
                    placeHolder={
                      <span className="after:content-['*'] after:mr-0.5 after:text-red-500">
                        الخدمة
                      </span>
                    }
                  />
                </div>
              ) : (
                <div className="w-full">
                  <MultiSelect
                    options={subCategories.map((e) => {
                      return { label: e.name, value: e.id };
                    })}
                    value={subCategory}
                    onChange={setSubCategory}
                    styles={dropdownStyles}
                    placeHolder={
                      <span className="after:content-['*'] after:mr-0.5 after:text-red-500">
                        المحصول
                      </span>
                    }
                  />
                </div>
              )
            ) : (
              ""
            )}

            <div className="flex flex-row-reverse gap-6 w-full my-3">
              <div className="w-full text-right flex flex-col gap-3">
                <label className="font-bold before:content-['*'] before:ml-0.5 before:text-red-500">

                  {information.type === "cooperative" ?
                    (
                      <span className="">اسم التعاونية</span>
                    ) : (
                      information.type === "service_provider" ?
                        (
                          <span className="">اسم الشركة
                          </span>
                        ) : (
                          information.type === "farmer" ?
                            (
                              <span className="">الاسم </span>
                            ) : (
                              <span className="">اسم المستخدم</span>
                            )
                        )
                    )
                  }
                </label>
                <input
                  className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0  focus:border-primary"
                  value={information.name}
                  onChange={(e) =>
                    setInformation({ ...information, name: e.target.value })
                  }
                  required
                  placeholder="إدخل الإسم"
                  type="text"
                  dir="rtl"
                />
              </div>
              <div className="w-full text-right flex flex-col gap-3">
                <label className="font-bold before:content-['*'] before:ml-0.5 before:text-red-500 ">
                  رقم الهاتف
                </label>
                <input
                  className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0  focus:border-primary"
                  value={val}
                  onChange={(e) => {
                    setInformation({
                      ...information,
                      phonenumber: handelPhonenumber(e.target.value),
                    });
                    setVal((v) =>
                      e.target.validity.valid ? e.target.value : v
                    );
                  }}
                  required
                  placeholder="  إدخل رقم الهاتف ( 09xxxxxx)"
                  type="number"
                  pattern="[0-9]*"
                  dir="rtl"
                />
              </div>
            </div>
            <div className="flex flex-row-reverse gap-6 w-full my-3">
              <div className="w-full text-right flex flex-col gap-3">
                <label className="font-bold before:content-['*'] before:ml-0.5 before:text-red-500 ">
                  كلمة المرور{" "}
                </label>

                <input
                  className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0  focus:border-primary"
                  value={information.password}
                  onChange={(e) =>
                    setInformation({ ...information, password: e.target.value })
                  }
                  id="phone"
                  placeholder=" إدخل كلمة المرور"
                  type="password"
                  dir="rtl"
                />
              </div>
              <div className="w-full text-right flex flex-col gap-3">
                <label className="font-bold before:content-['*'] before:ml-0.5 before:text-red-500 ">
                  تأكيد كلمة المرور{" "}
                </label>

                <input
                  className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0  focus:border-primary"
                  value={information.repassword}
                  onChange={(e) =>
                    setInformation({
                      ...information,
                      repassword: e.target.value,
                    })
                  }
                  placeholder="تأكيد كلمة المرور"
                  type="password"
                  dir="rtl"
                />
              </div>


              {/* Forget Password Link - Added below password fields */}
              <div className="text-left w-full mt-2">
                <button
                  type="button"
                  onClick={handleForgetPassword}
                  className="text-primary hover:text-blue-700 text-sm font-medium underline transition-colors duration-200"
                >
                  نسيت كلمة المرور؟
                </button>
              </div>
            </div>
            {information.type === "cooperative" ? (
              <div className="flex flex-row-reverse gap-6 w-full my-3">
                <div className="w-full text-right flex flex-col gap-3">
                  <label className="font-bold before:content-['*'] before:ml-0.5 before:text-red-500">
                    عدد الأعضاء
                  </label>

                  <input
                    dir="rtl"
                    className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0  focus:border-primary"
                    onChange={(e) =>
                      setInformation({
                        ...information,
                        NoOfMembers: parseInt(e.target.value),
                      })
                    }
                    required
                    placeholder="عدد الأعضاء"
                    type="number"
                  />
                </div>
              </div>
            ) : (
              information.type != "service_provider" && (
                <div className="flex flex-row-reverse gap-6 w-full my-3">
                  <div className="w-full text-right flex flex-col gap-3">
                    <label className="font-bold before:content-['*'] before:ml-0.5 before:text-red-500">
                      النوع
                    </label>
                    <ReactSelect
                      options={[
                        { label: "ذكر", value: "male" },
                        { label: "أنثى", value: "female" },
                      ]}
                      // value={subCategory}
                      styles={dropdownStyles}
                      onChange={(e) => (
                        setInformation({
                          ...information,
                          gender: e.value ? e.value : null,
                        }),
                        analyticsEvent("User Gender", e.value)
                      )}
                      hideSelectedOptions={false}
                      closeMenuOnSelect={true}
                      isRtl
                      required
                      placeholder="النوع"
                    />
                  </div>
                  <div className="w-full text-right flex flex-col gap-3">
                    <label className="font-bold before:content-['*'] before:ml-0.5 before:text-red-500">
                      تاريخ الميلاد
                    </label>

                    <input
                      className="border-[#D1CFCF] border-2 rounded-[13.539px] h-[47px] w-full placeholder:font-medium placeholder:text-[#999797] placeholder:text-sm focus:bg-[#F1F1F1] focus:ring-0  focus:border-primary"
                      onChange={(e) => (
                        setInformation({
                          ...information,
                          dob: e.target.value ? new Date(e.target.value) : null,
                        }),
                        analyticsEvent(
                          "User DOB",
                          new Date(e.target.value).toLocaleString()
                        )
                      )}
                      required
                      placeholder=" تاريخ الميلاد "
                      type="date"
                      max="2010-12-31"
                    />
                  </div>
                </div>
              )
            )}
            <div className="w-96 h-[20vh] border-primary border-[1px] bg-gray-50 rounded-md flex justify-center items-center text-gray-500">
              <input
                type="file"
                id="file"
                className="hidden"
                onChange={(e) => upload(e.target.files[0])}
              />
              <label
                htmlFor="file"
                className="font-bold before:mr-1 before:text-red-500"
              >
                أرفق مستنداتك
              </label>
            </div>
            <div className="h-5" />
            <div className="flex flex-row gap-3">
              {media.length > 0 &&
                media.map((src, index) => {
                  const fileExtension = src.split(".").pop().toLowerCase();
                  const isDocument = allowedExtensions.includes(fileExtension);

                  return isDocument ? (
                    fileExtension === "pdf" ? (
                      <object
                        key={index}
                        data={src}
                        type="application/pdf"
                        className="w-16 h-20 border border-gray-300 rounded"
                      >
                        <p>PDF Preview not available</p>
                      </object>
                    ) : (
                      <iframe
                        key={index}
                        src={src}
                        className="w-16 h-20 border border-gray-300 rounded"
                        title="Document Preview"
                      />
                    )
                  ) : (
                    <img
                      src={src}
                      className="w-16 h-16 object-cover border border-gray-300 rounded"
                      alt="Preview"
                      key={index}
                    />
                  );
                })}
            </div>
            <div className="h-5" />

          </div>

          <div className="relative w-full flex flex-col  text-center gap-3 mb-8">
            <button
              className="w-full h-[47px] font-bold text-white rounded-[13.539px] bg-primary"
              onClick={() => register()}
            >
              إنشاء حساب
            </button>
            <p className="text-[#999797] text-sm">أو</p>
            <Link to="/signin">
              <button className="w-full h-[47px]  font-bold  text-primary border-primary border-2 rounded-[13.539px]">
                تسجيل دخول
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default Signup;
const dropdownStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "13.539px",
    height: "49px",
    paddingLeft: "8px",
    paddingRight: "8px",
    fontWeight: "300",
    border: state.isFocused ? "2px solid #23AA49" : "2px solid #D1CFCF",
    boxShadow: state.isFocused ? "none" : "none",
    "&:hover": {
      boxShadow: "none",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
};
